import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataService } from './data.service';
 
@Injectable()
export class AuthGuard implements CanActivate {
menu:any=[];
errMsg:any;
    
    constructor(private router: Router, private dataService: DataService) { }
 
    canActivate(route: ActivatedRouteSnapshot, state:RouterStateSnapshot):boolean {
        //console.log(route);
        //console.log(state);
        //console.log(sessionStorage.getItem('csiBILLusr'));
        //console.log(sessionStorage.getItem('csiBILLusrR'));
        //console.log(sessionStorage.getItem('csiBILLusrX'));

        //--> DESARROLLO SIN AUTH
        //return true;

        var xcep=[];
        if(sessionStorage.getItem('csiBILLusrX'))
            xcep=sessionStorage.getItem('csiBILLusrX').toString().split(',');
        if (sessionStorage.getItem('csiBILLusr')) {
            // logged in so return true
            //--> Validar modulos
            //console.log(sessionStorage.getItem('csiBILLusrX'));
            for(var m=0;  m<xcep.length; m++){
                if(xcep[m]==state.url.replace("/","")){
                    this.router.navigate(['/']);
                    return false
                }
            }
            return true;
        }

        // not logged in so redirect to login page with the return url
            this.router.navigate(['/login']);
            return false;                

    }

}